import { lazy } from "react";
import "@excalidraw/excalidraw/index.css";

const ExcalidrawCanvas = lazy(async () => {
  const { Excalidraw, MainMenu, Footer } = await import("@excalidraw/excalidraw");

  function WhiteboardCanvas(props: React.ComponentProps<typeof Excalidraw>) {
    return (
      <>
        <style>{`.default-sidebar-trigger { display: none !important; }`}</style>
        <Excalidraw {...props}>
          <MainMenu>
            <MainMenu.DefaultItems.ClearCanvas />
            <MainMenu.DefaultItems.SaveAsImage />
            <MainMenu.DefaultItems.ChangeCanvasBackground />
            <MainMenu.DefaultItems.ToggleTheme />
          </MainMenu>
          <Footer />
        </Excalidraw>
      </>
    );
  }

  return { default: WhiteboardCanvas };
});

export default ExcalidrawCanvas;
